import { render, staticRenderFns } from "./DemoVisitor.vue?vue&type=template&id=70d10075&scoped=true"
import script from "./DemoVisitor.vue?vue&type=script&lang=js"
export * from "./DemoVisitor.vue?vue&type=script&lang=js"
import style0 from "./DemoVisitor.vue?vue&type=style&index=0&id=70d10075&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d10075",
  null
  
)

export default component.exports